import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, Collapse, ListGroup,
} from 'react-bootstrap';
import { useDrop } from 'react-dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import SKDColumnItem from './columnItem';
import itemTypes from '../itemTypes';
import { columnsPropType } from '../../hooks';
import Background from '../../../../components/blanks/common/Background';
import corner4 from '../../../../assets/img/illustrations/corner-4.png';

function SKDColumnsList({
  columns, activeColumn, onClick, onDblClick, onDragEnd, onSubColumnClick, onChangeHierarchy,
  cardText, cardTitle,
}) {
  const [padded, setPadded] = useState(null);
  const onDragEndHandler = useCallback(
    (item) => {
      onDragEnd(item, padded);
    },
    [onDragEnd, padded],
  );
  const [{
    isOver, isOverCurrent, didDrop,
  }, ref] = useDrop({
    accept: [itemTypes.availableField, itemTypes.column],
    drop: (item) => onDragEndHandler(item),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true }),
      // CanDrop: monitor.canDrop(),
      didDrop: monitor.didDrop(),
    }),
  });

  const setPaddedHandler = useCallback(
    setPadded,
    [setPadded],
  );

  useEffect(() => {
    if ((!isOver && !isOverCurrent && !didDrop) || (isOver && isOverCurrent && !didDrop)) {
      setPadded(null);
    }
  }, [didDrop, isOver, isOverCurrent]);
  const [helpOpened, setHelpOpened] = useState(false);
  return (
    <div className="w-100 h-100 d-flex flex-column" ref={ref}>
      <Card className="rounded-0 border-bottom">
        <Background
          image={corner4}
          className="bg-card d-none d-sm-block rounded-0"
        />
        <Card.Body>
          <div className="d-flex align-items-center justify-content-between">
            <Card.Title>
              {cardTitle}
            </Card.Title>
            <Button onClick={() => setHelpOpened((o) => !o)} size="sm" variant="link" className="z-1">
              <FontAwesomeIcon icon={faQuestionCircle} bounce={helpOpened} />
            </Button>
          </div>
          <Collapse in={helpOpened}>
            <Card.Text>
              {cardText}
            </Card.Text>
          </Collapse>
        </Card.Body>

        <ListGroup className="flex-fill scrollbar fs--1">
          {columns.map((f) => (
            <SKDColumnItem
              subcolumns={f.items}
              name={f.name}
              key={f.name}
              onClick={onClick}
              onDblClick={onDblClick}
              onSubColumnClick={onSubColumnClick}
              active={activeColumn === f.name}
              onHover={setPaddedHandler}
              padded={padded === f.name}
              onChangeHierarchy={onChangeHierarchy}
            />
          ))}
        </ListGroup>

      </Card>
    </div>
  );
}

SKDColumnsList.propTypes = {
  columns: columnsPropType.isRequired,
  cardTitle: PropTypes.node.isRequired,
  cardText: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  onSubColumnClick: PropTypes.func.isRequired,
  onDblClick: PropTypes.func,
  activeColumn: PropTypes.string,
  onDragEnd: PropTypes.func.isRequired,
  onChangeHierarchy: PropTypes.func.isRequired,
};

SKDColumnsList.defaultProps = {
  activeColumn: null,
  onDblClick: () => null,
};
export default SKDColumnsList;
